import React, { useEffect, useState } from "react";
import Tabs from "components/tabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { setDefaultPosition } from "components/measuring/lib/helpers";
import { usePositions } from "components/measuring/hooks/api/use-positions";
import { useGetMeasurements } from "components/shipment-editor/measurements/hooks/use-get-measurements";
import { MeasurementsBox } from "shared/components/measurements/measurement-box";
import { useModal } from "shared/hooks/use-modal";
import { EditMeasurementsModal } from "components/photography/components/edit-measurements-modal";
import { SourcePage } from "shared/taskTypeMap";

export const MeasurementsDisplay = ({ measuringWipKey, isFinalized }) => {
    const [positionList, setPositionList] = useState({ active: [], available: [], all: [] });
    const { data: positionListData, isSuccess: isPositionsSuccess } = usePositions();
    const { open: isEditMeasurementsModalOpen, onOpen: handleOpenEditMeasurementsModal, onClose: handleCloseEditMeasurementsModal } = useModal();
    const [selectedTab, setSelectedTab] = useState(0);
    const { data: measurements, isSuccess: isMeasurementsSuccess, refetch: refetchMeasurements } = useGetMeasurements(measuringWipKey);

    useEffect(() => {
        if (!measurements && !isMeasurementsSuccess) {
            return;
        }

        if (positionListData && isPositionsSuccess) {
            return setPositionList(setDefaultPosition(positionListData, measurements));
        }
    }, [positionListData, isPositionsSuccess, measurements, isMeasurementsSuccess]);

    const handleCloseModal = () => {
        handleCloseEditMeasurementsModal();
        refetchMeasurements();
    };

    const tabContent = measurements
        ?.filter((measure) => measure.positionValue === positionList.active[selectedTab]?.value)
        .reduce((measureList, measure) => {
            const newMeasure = {
                type: measure.type,
                position: measure.positionValue,
                dimensions: Object.fromEntries(
                    Object.entries({
                        height: measure.height.value || 0,
                        width: measure.width.value || 0,
                        depth: measure.depth.value || 0,
                        weight: measure.weight.value || 0,
                    }).sort((a, b) => b[1] - a[1])
                ),
                uom: {
                    height: measure.height.uom,
                    width: measure.width.uom,
                    depth: measure.depth.uom,
                    weight: measure.weight.uom,
                },
            };
            return [...measureList, newMeasure];
        }, [])
        .map((measure) => {
            return (
                <div key={`${measure.position}_${measure.type}`}>
                    {measure.type === "Imperial" && (
                        <MeasurementsBox
                            dimensions={measure.dimensions}
                            uom={measure.uom}
                            label="Imperial"
                        />
                    )}
                    {measure.type === "Metric" && (
                        <MeasurementsBox
                            dimensions={measure.dimensions}
                            uom={measure.uom}
                            label="Metric"
                        />
                    )}
                </div>
            );
        });

    if (!measurements?.length) {
        return null;
    }

    return (
        <>
            <Tabs
                readOnly={true}
                selectedTab={selectedTab}
                tabs={positionList.active}
                tabClassOverride={"-primary -no-focus"}
                tabListClasses={"border-bottom"}
                tabContentClasses={"position-relative no-border-top"}
                reportSelectedTab={(tabIndex) => {
                    setSelectedTab(tabIndex);
                }}
            >
                <div>
                    {tabContent}
                    {isMeasurementsSuccess && !isFinalized && (
                        <button
                            className="button -text -absolute abs-b-16 abs-l-44"
                            onClick={handleOpenEditMeasurementsModal}
                        >
                            <FontAwesomeIcon icon={faPencilAlt} /> Edit
                        </button>
                    )}
                </div>
            </Tabs>
            <EditMeasurementsModal
                sourcePage={SourcePage["finalqa.standard"]}
                open={isEditMeasurementsModalOpen}
                onClose={handleCloseModal}
                existingMeasurements={measurements}
                showTabs
                activePositions={positionList.active}
                selectedTabOverride={selectedTab}
                setSelectedTabOverride={setSelectedTab}
            />
        </>
    );
};
